import { render } from "./MagneticCarousel.vue?vue&type=template&id=3a82e076&scoped=true"
import script from "./MagneticCarousel.vue?vue&type=script&lang=js"
export * from "./MagneticCarousel.vue?vue&type=script&lang=js"

import "./MagneticCarousel.vue?vue&type=style&index=0&id=3a82e076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a82e076"]])

export default __exports__